export default __webpack_public_path__ + "media/images/features/ana/japan_map-29e3ed848af6aea4c1f37ddffdfb13b2.png";